import { createSlice } from '@reduxjs/toolkit';
// import { database } from 'faker/locale/en_AU';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  clients: null,
  cadences: null,
  createdClient: null,
  detailInfo: null,
  updateClient: null,
  scheduledPauses: null,
  clientEndpoints: null,
  createEndpoints: null,
  updateEndpoints: null,
  duplicateEndpoints: null,
  endpointMap: null,
  updateMap: null,
  clientTokens: null,
  createTokens: null,
  deleteTokens: null,
  updateTokens: null,
  clientIntegrationsEx: null,
  postBacks: null,
  createIntegrationsEx: null,
  deleteIntegrationsEx: null,
  updateIntegrationsEx: null,
  columns: null,
  data: null,
  leadSearchData: null,
  saveLeadData: null,
  fieldMappings:[],
  authenticationTypes:[],
  sendTypes:[],
  endPointTypes: [],
  lqclientproductlist:[],
  lqsaidlist:[],
  cadencenames:[],
  clientExceptions:[],
  createCadence: null,
  duplicateCadence: null,
  updateCadence: null,
  deleteCadences: null,
  createPhoneConf: null,
  updatePhoneConf: null,
  createSMSConf: null,
  updateSMSConf: null,
  createEmailConf: null,
  updateEmailConf: null,
  createTouchPoint: null,
  archiveCadences: null,
  createFolloup: null,
  createEndCadence: null,
  updateFolloup: null,
  deleteFolloup: null,
  deleteEndCadence: null,
  updateEndCadence: null,
  endMap : null,
  disposition: null,
  touchPoint: null,
  inbountTouch: null,
  leadData: null,
  options: null,
  bookings: [],
  endCadenceType: null,
  cadenceDetailData: null
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    endLoading(state) {
      state.isLoading = false;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    formatError(state, action) {
      state.error = false;
    },

    saveColumn(state, action) {
      state.isLoading = false;
      state.columns = action.payload;
    },

    saveData(state, action) {
        state.isLoading = false;
        state.data = action.payload;
    },

    saveLeadData(state, action) {
      state.isLoading = false;
      state.saveLeadData = action.payload;
    },

    getClient(state, action) {
      state.isLoading = false;
      state.clients = action.payload;
    },

    getCadence(state, action) {
      state.isLoading = false;
      state.cadences = action.payload;
    },

    getLeadData(state, action) {
      state.isLoading = false;
      state.leadSearchData = action.payload;
    },

    //GET BOOKING LIST
    getBookingList(state, action) {
      state.isLoading = false;
      state.bookings = action.payload;
    },

    // GET PROFILE
    getClientIntegration(state, action) {
      state.isLoading = false;
      state.clients = action.payload;
    },

    // GET PROFILE
    getExceptionsByClientID(state, action) {
      state.isLoading = false;
      state.clientExceptions = action.payload;
    },
    // GET PROFILE
    clearExceptionsByClientId(state, action) {
      state.isLoading = false;
      state.clientExceptions = action.payload;
    },

    // GET PROFILE
    getFieldMappings(state, action) {
      state.isLoading = false;
      state.fieldMappings = action.payload;
    },
    getLqClientProductList(state, action) {
      state.isLoading = false;
      state.lqclientproductlist = action.payload;
    },

    getSaidID(state, action) {
      state.isLoading = false;
      state.lqsaidlist = action.payload;
    },

    getCadenceNames(state, action) {
      state.isLoading = false;
      state.cadencenames = action.payload;
    },

    //CREACT CLIENTINTEGRATION ACCOUNT
    createClientIntegration(state, action) {
      state.isLoading = false;
      state.createdClient = action.payload;
    },

    // TODO - finalize
    createClient(state, action) {
      state.isLoading = false;
      state.createdClient = action.payload;
    },    

    createClientEndpoints(state, action) {
      state.isLoading = false;
      state.createEndpoints = action.payload;
    },

    createClientCadences(state, action) {
      state.isLoading = false;
      state.createCadence = action.payload;
    },

    createClientTouchPoint(state, action) {
      state.isLoading = false;
      state.createTouchPoint = action.payload;
    },

    createClientFollowUp(state, action) {
      state.isLoading = false;
      state.createFolloup = action.payload;
    },

    updateClientFollowUp(state, action) {
      state.isLoading = false;
      state.updateFolloup = action.payload;
    },

    createClientEndCadnece(state, action) {
      state.isLoading = false;
      state.createEndCadence = action.payload;
    },

    updateClientEndCadnece(state, action) {
      state.isLoading = false;
      state.updateEndCadence = action.payload;
    },

    deleteClientEndCadence(state, action) {
      state.isLoading = false;
      state.deleteEndCadence = action.payload;
    },
    deleteClientFollowUp(state, action) {
      state.isLoading = false;
      state.deleteFolloup = action.payload;
    },
    
    createClientEndCadence(state, action) {
      state.isLoading = false;
      state.createEndCadence = action.payload;
    },

    updateClientEndCadence(state, action) {
      state.isLoading = false;
      state.updateEndCadence = action.payload;
    },
    
    duplicateClientCadences(state, action) {
      state.isLoading = false;
      state.duplicateCadence = action.payload;
    },

    createdPhoneConfiguration(state, action) {
      state.isLoading = false;
      state.createPhoneConf = action.payload;
    },

    createdEmailConfiguration(state, action) {
      state.isLoading = false;
      state.createEmailConf = action.payload;
    },

    createdSMSConfiguration(state, action) {
      state.isLoading = false;
      state.createSMSConf = action.payload;
    },

    updatedPhoneConfiguration(state, action) {
      state.isLoading = false;
      state.updatePhoneConf = action.payload;
    },
    
    updatedSMSConfiguration(state, action) {
      state.isLoading = false;
      state.updateSMSConf = action.payload;
    },

    updatedEmailConfiguration(state, action) {
      state.isLoading = false;
      state.updateEmailConf = action.payload;
    },

    deleteClientCadences(state, action) {
      state.isLoading = false;
      state.deleteCadences = action.payload;
    },

    ArchiveClientCadences(state, action) {
      state.isLoading = false;
      state.archiveCadences = action.payload;
    },

    getScheduledPauses(state, action) {
      state.isLoading = false;
      state.scheduledPauses = action.payload;
    },

    updateScheduledPauses(state, action) {
      state.isLoading = false;
      state.scheduledPauses = action.payload;
    },    
    
    updateClientEndpoints(state, action) {
      state.isLoading = false;
      state.updateEndpoints = action.payload;
    },

    duplicateClientEndpoints(state, action) {
      state.isLoading = false;
      state.duplicateEndpoints = action.payload;
    },    

    updateClientCadences(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },
    
    startCadences(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    pauseCadences(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    updateClientTokens(state, action) {
      state.isLoading = false;
      state.updateTokens = action.payload;
    },

    createClientTokens(state, action) {
      state.isLoading = false;
      state.createTokens = action.payload;
    },

    deleteClientTokens(state, action) {
      state.isLoading = false;
      state.deleteTokens = action.payload;
    },

    updateClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.updateIntegrationsEx = action.payload;
    },

    createClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.createIntegrationsEx = action.payload;
    },

    deleteClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.deleteIntegrationsEx = action.payload;
    },

    getDetailInfo(state, action) {
      state.isLoading = false;
      state.detailInfo = action.payload;
    },
    
    // TODO - Finalize
    updateClient(state, action) {
      state.isLoading = false;
      state.updateClient = action.payload;
    },

    updateCadence(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    updateClientIntegration(state, action) {
      state.isLoading = false;
      state.updateClient = action.payload;
    },

    getClientEndpoints (state, action) {
      state.isLoading = false;
      state.clientEndpoints = action.payload;
    },

    getClientTokens (state, action) {
      state.isLoading = false;
      state.clientTokens = action.payload;
    },

    getClientIntegrationsEx (state, action) {
      state.isLoading = false;
      state.clientIntegrationsEx = action.payload;
    },

    getPostBacks (state, action) {
      state.isLoading = false;
      state.postBacks = action.payload;
    },

    getEndpointMap (state, action) {
      state.isLoading = false;
      state.endpointMap = action.payload;
    },

    getAuthenticationType (state, action) {
      state.isLoading = false;
      state.authenticationTypes = action.payload;
    },

    getSendType (state, action) {
      state.isLoading = false;
      state.sendTypes = action.payload;
    },

    getEndpointType (state, action) {
      state.isLoading = false;
      state.endPointTypes = action.payload;
    },

    updateEndpointMap (state, action) {
      state.isLoading = false;
      state.updateMap = action.payload;
    },
    getEndPointMapping (state, action){
      state.isLoading = false;
      state.endMap = action.payload;
    },
    getFinalDisposition (state, action) {
      state.isLoading = false;
      state.disposition = action.payload;
    },
    getTouchPointOutcome (state, action) {
      state.isLoading = false;
      state.touchPoint = action.payload;
    },
    getInboundTouchpoint (state, action) {
      state.isLoading = false;
      state.inbountTouch = action.payload;
    },
    getIncludeLeadData (state, action) {
      state.isLoading = false;
      state.leadData = action.payload;
    },
    getSubAccount (state, action){
      state.isLoading = false;
      state.subAccountData = action.payload;
    },
    getOptions (state, action){
      state.isLoading = false;
      state.options = action.payload;
    },
    getEndCadenceType (state, action){
      state.isLoading = false;
      state.endCadenceType = action.payload;
    },
    getCadenceDetail (state, action) {
      state.isLoading = false;
      state.cadenceDetailData = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow } = slice.actions;

export function getCadences() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/cadence/management/list');
      dispatch(slice.actions.getCadence(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCadencesEndpoint(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/cadence_endpoint', {lead_id: id});
      dispatch(slice.actions.getCadence(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function leadSearch(data, isLoading) {
  return async (dispatch) => {
    if(isLoading) {
      dispatch(slice.actions.startLoading());
    }
    try {
      const response = await axios.post('/iapi/cadence/management/leadSearch', data);
      dispatch(slice.actions.getLeadData(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLeadDetails(lead_id, isLoading) {
  return async (dispatch) => {
    if(isLoading) {
      dispatch(slice.actions.startLoading());
    }
    try {
      const response = await axios.get(`/iapi/cadence/management/lead/${lead_id}`);
      // dispatch(slice.actions.getLeadData(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function duplicationCadence(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/duplicate/'+data.cadence, data);
      if(response.data.status){
        dispatch(slice.actions.duplicateClientCadences(response.data));
      }
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createPhoneConfiguration(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      if(!data.id){
        const response = await axios.post('/iapi/cadence/admin/config/phone/'+data.cadence_id+'/'+data.client_integration_id, data);
        if(response.data.status){
          dispatch(slice.actions.createdPhoneConfiguration(response.data));
        } else {
          dispatch(slice.actions.endLoading());
        }
        return response.data;
      }else{
        const response = await axios.put('/iapi/cadence/admin/config/phone/'+data.cadence_id+'/'+data.client_integration_id, data);
        if(response.data.status){
          dispatch(slice.actions.updatedPhoneConfiguration(response.data));
        } else {
          dispatch(slice.actions.endLoading());
        }
        return response.data;
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createSMSConfiguration(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      if(!data.id){
        const response = await axios.post('/iapi/cadence/admin/config/sms/'+data.cadence_id+'/'+data.client_integration_id, data);
        if(response.data.status){
          dispatch(slice.actions.createdSMSConfiguration(response.data));
        } else {
          dispatch(slice.actions.endLoading());
        }
        return response.data;
      }else{
        const response = await axios.put('/iapi/cadence/admin/config/sms/'+data.cadence_id+'/'+data.client_integration_id, data);
        if(response.data.status){
          dispatch(slice.actions.updatedSMSConfiguration(response.data));
        } else {
          dispatch(slice.actions.endLoading());
        }
        return response.data;
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createEmailConfiguration(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      if(!data.id){
        const response = await axios.post('/iapi/cadence/admin/config/email/'+data.cadence_id+'/'+data.client_integration_id, data);
        if(response.data.status){
          dispatch(slice.actions.createdEmailConfiguration(response.data));
        } else {
          dispatch(slice.actions.endLoading());
        }
        return response.data;
      }else{
        const response = await axios.put('/iapi/cadence/admin/config/email/'+data.cadence_id+'/'+data.client_integration_id, data);
        if(response.data.status){
          dispatch(slice.actions.updatedEmailConfiguration(response.data));
        } else {
          dispatch(slice.actions.endLoading());
        }
        return response.data;
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function deleteCadence(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/delete/'+data.client_integration_id, {cadence_id:data.id});
      dispatch(slice.actions.deleteClientCadences(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function archiveCadence(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/archive/', {cadence: data.id});
      dispatch(slice.actions.ArchiveClientCadences(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createTouchPoint(cadence_id, client_id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put('/iapi/cadence/admin/config/touchpoints/'+cadence_id+'/'+client_id, data);
      dispatch(slice.actions.createClientTouchPoint(response));
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createPhoneTestLead(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/validate/phone', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createSMSTestLead(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/validate/sms', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createEmailTestLead(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/validate/email', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createFolloup(cadence_id, client_id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      if(data.follow_up_cadence.id) {
        const response = await axios.put('/iapi/cadence/admin/config/followups/'+cadence_id+'/'+client_id, data);
        dispatch(slice.actions.updateClientFollowUp(response));
        if(response.data) {
          return {status: true, type: 'update'}
        }
      }else {
        const response = await axios.post('/iapi/cadence/admin/config/followups/'+cadence_id+'/'+client_id, data);
        dispatch(slice.actions.createClientFollowUp(response));
        if(response.data) {
          return {status: true, type: 'create'}
        }

      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function deleteFolloup(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/config/followups/delete', {id: id});
      dispatch(slice.actions.deleteClientFollowUp(response));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function deleteEndCadence(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/config/endcadence/delete', {id: id});
      dispatch(slice.actions.deleteClientEndCadence(response));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createEndCadence(cadence_id, client_id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
        const response = await axios.post('/iapi/cadence/admin/config/endcadence/'+cadence_id+'/'+client_id, data);
        if ( data?.id ) {
          dispatch(slice.actions.updateClientEndCadence(response));
        } else {
          dispatch(slice.actions.createClientEndCadence(response));
        }
        return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createCadence(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/create/'+data.client_integration_id, data);
      dispatch(slice.actions.createClientCadences(response));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

// ----------------------------------------------------------------------

export function getScheduledPauses(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const firstId = data.id.split(",")[0];
      const firstClientIntegrationId = data.client_integration_id.split(",")[0];
      const response = await axios.get('/iapi/cadence/admin/config/scheduledpause/' +
        firstId + "/" + firstClientIntegrationId, data);
      dispatch(slice.actions.getScheduledPauses(response.data));
      return response.data;;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateScheduledPauses(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const firstId = data.id.split(",")[0];
      const firstClientIntegrationId = data.client_integration_id.split(",")[0];
      const response = await axios.post('/iapi/cadence/admin/config/scheduledpause/' +
        firstId + "/" + firstClientIntegrationId, data);
      dispatch(slice.actions.updateScheduledPauses(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateClientCadence(data, endCadence) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/update/' + data.client_integration_id, {
        name: data.name,
        description: data.description,
        cadence_id: data.id,
        status: data.status ? parseInt(data.status) : null,
        wait_close_time: data.wait_close_time,
        end_cadence: endCadence
      });
      dispatch(slice.actions.updateClientCadences(response.data));
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function startCadences(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/start', data);
      dispatch(slice.actions.startCadences(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function pauseCadences(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/pause', data);
      dispatch(slice.actions.pauseCadences(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function formatUpdateIntegrationsEx() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClientIntegrationsEx(null));
  };
}


// ----------------------------------------------------------------------
export function getCallCadenceList(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/cadences/show/'+id);
      dispatch(slice.actions.getCadenceNames(response.data));
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getLqCadencesList(id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/clients/cadences/'+id);
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getPhoneConfigData(cadence_id, client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/admin/config/phone/'+cadence_id+'/'+client_integration_id);
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getCadenceInfo(cadence_id, client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/admin/config/all/'+cadence_id+'/'+client_integration_id);
      // return response.data
      dispatch(slice.actions.getCadenceDetail(response.data));
    } catch (error) {
      return []
    }
  };
}

export function viweSMSLog(cadence_id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/admin/logs/sms', {cadence_id: cadence_id});
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function viwePhoneLog(cadence_id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/admin/logs/phone', {cadence_id: cadence_id});
      return (response.data)
    } catch (error) {
      return []
    }
  };
}

export function viweEmailLog(cadence_id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/admin/logs/email', {cadence_id: cadence_id});
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getSMSConfigData(cadence_id, client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/admin/config/sms/'+cadence_id+'/'+client_integration_id);
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getEndCadenceType() {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/admin/config/getEndCadenceType');
      dispatch(slice.actions.getEndCadenceType(response.data));
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getTouchPointData(cadence_id, client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/admin/config/touchpoints/'+cadence_id+'/'+client_integration_id);
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getEmailConfigData(cadence_id, client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/admin/config/email/'+cadence_id+'/'+client_integration_id);
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function setCallCadenceList(id,data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadences/update/'+id, {cadences:JSON.stringify(data)});
      dispatch(slice.actions.getCadenceNames(response.data));
      return response.data
    } catch (error) {
      return []
    }
  };
}

// ----------------------------------------------------------------------
// Cadence stuff:

export function getClientCadences(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/cadence/admin/list/'+ id);
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLeadLists(cadence_id, filter) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/leads', {
          "cadence_id" : cadence_id,
          "filters" : filter
      });
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPendingLeadLists(endpoint_id, filter) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/pendingLeads', {
          "endpoint_id" : endpoint_id,
          "filters" : filter
      });
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
};

export function previousTouchpoints(lead_id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/previoustouchpoints', {
          "lead_id" : lead_id,
      });
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getActiveCadences(client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id);
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEndCadence(client_integration_id, cadence_id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.get('/iapi/cadence/admin/config/endcadence/'+cadence_id+'/'+client_integration_id);
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLeadDetail(id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/management/lead', {lead_id: id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function pullLead(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/management/pull_lead', {lead_id: id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function multi_pull_lead(ids) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/management/multi_pull_lead', {lead_ids: ids});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function moveToCadence(lead_id, cadence_id, old_cadence) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/management/move_to_cadence', {lead_id: lead_id, cadence_id: cadence_id, old_cadence: old_cadence});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTouchpoints(id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/management/touchpoints', {lead_id: id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCadenceStatus(id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/management/cadence_status', {lead_id: id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getTouchpointsInbound(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/management/touchpoints_inbound', {lead_id: id});
      let data  = response['data']
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPastCadence(cadence_id, lead_id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/management/previous_cadence_summary', {cadence_id: cadence_id, lead_id: lead_id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function sendEmailTest(postData) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/admin/validate/emailmessage', postData);
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function sendSMSTest(postData) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/admin/validate/smsmessage', postData);
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFollowUp(client_integration_id, cadence_id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.get('/iapi/cadence/admin/config/followups/'+cadence_id+'/'+client_integration_id);
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFollowUpTypes() {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.get('/iapi/cadence/admin/config/getfollowuprules');
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFollowUpTargets() {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.get('/iapi/cadence/admin/config/getfollowuptargets');
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateCadenceStatus(status, cadence_id, client_id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let  response;
      if(status == 1) {
        response = await axios.post('/iapi/cadence/admin/activate', {cadence: cadence_id});
      }else if(status == 3) {
        response = await axios.post('/iapi/cadence/admin/delete/'+client_id, {cadence_id: cadence_id});
      }else if(status == 0) {
        response = await axios.post('/iapi/cadence/admin/archive', {cadence: cadence_id});
      }
      return response
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
